<template>
  <div class="map-root">
    <div
      v-show="action_buttons || cluster_items_selected.length"
      class="feature-action-buttons"
    >
      <div>
        <a
          id="btn-save"
          :class="{ 'feature-action-buttons-active': active_button == 1 }"
          @click="active_button = 1"
          class="button is-small"
          v-tooltip="{
            content: localization('app-save', 'Save'),
            placement: 'bottom-center',
          }"
        >
          <img
            v-if="active_button == 1"
            src="../../assets/icons/save-active.svg"
            alt
            srcset
          />
          <img v-else src="../../assets/icons/save.svg" alt srcset />
        </a>
        <!-- 'is-disabled': selected_features && selected_features.length > 1, -->
        <a
          id="btn-edit"
          :class="{
            'feature-action-buttons-active': active_button == 2,
          }"
          @click="active_button = 2"
          class="button is-small"
          v-tooltip="{
            content: localization('app-edit', 'Edit'),
            placement: 'bottom-center',
          }"
        >
          <img
            v-if="active_button == 2"
            src="../../assets/icons/edit-active.svg"
            alt
            srcset
          />
          <img v-else src="../../assets/icons/edit.svg" alt srcset />
        </a>
        <a
          id="btn-delete"
          :class="{ 'feature-action-buttons-active': active_button == 3 }"
          @click="active_button = 3"
          class="button is-small"
          v-tooltip="{
            content: localization('app-delete', 'Delete'),
            placement: 'bottom-center',
          }"
        >
          <img
            v-if="active_button == 3"
            src="../../assets/icons/delete-active.svg"
            alt
            srcset
          />
          <img v-else src="../../assets/icons/delete.svg" alt srcset />
        </a>
        <!-- <a
          id="cal-volume"
          :class="{
            'feature-action-buttons-active': active_button == 4,
            'is-disabled': selected_features && selected_features.length > 1,
          }"
          @click="active_button = 4"
          class="tool-btn button is-small"
          v-tooltip="{
            content: localization(
              'app-volume-calculation',
              'Volume calculation'
            ),
            placement: 'bottom-center',
          }"
        >
          <img
            v-if="active_button == 4"
            src="../../assets/icons/volumn-calculation-active.svg"
            alt
            srcset
          />
          <img
            v-else
            src="../../assets/icons/volumn-calculation.svg"
            alt
            srcset
          />
        </a>
        <a
          id="cal-elevation"
          :class="{
            'feature-action-buttons-active': active_button == 5,
            'is-disabled': selected_features && selected_features.length > 1,
          }"
          @click="active_button = 5"
          class="tool-btn button is-small"
          v-tooltip="{
            content: localization('app-elevation-profile', 'Elevation profile'),
            placement: 'bottom-center',
          }"
        >
          <img
            v-if="active_button == 5"
            src="../../assets/icons/elevation-active.svg"
            alt
            srcset
          />
          <img v-else src="../../assets/icons/elevation.svg" alt srcset />
        </a> -->
        <a
          id="feature-details"
          :class="{
            'feature-action-buttons-active': active_button == 6,
            'is-disabled': selected_features && selected_features.length > 1,
          }"
          @click="active_button = 6"
          class="tool-btn button is-small"
          title="Feature Details"
          v-tooltip="{
            content: localization('app-feature-details', 'Feature details'),
            placement: 'bottom-center',
          }"
        >
          <img
            v-if="active_button == 6"
            src="../../assets/icons/feature-details-active.svg"
            alt
            srcset
          />
          <img v-else src="../../assets/icons/feature-details.svg" alt srcset />
        </a>
        <!-- <span class="divider"></span>
        <a
          id="create-new-ticket"
          :class="{
            'feature-action-buttons-active': active_button == 7,
            'is-disabled': selected_features && selected_features.length > 1,
          }"
          @click="active_button = 7"
          class="tool-btn button is-small"
          v-tooltip="{
            content: localization('app-create-ticket', 'Create ticket'),
            placement: 'bottom-center',
          }"
        >
          <img
            v-if="active_button == 7"
            src="../../assets/icons/new-ticket-active.svg"
            alt
            srcset
          />
          <img v-else src="../../assets/icons/new-ticket.svg" alt srcset />
        </a>
        <a
          id="tickets-bulk-create"
          @click="
            active_button = 8;
            post_bulk_create_event('tickets-bulk-create');
          "
          v-if="lang_data"
          class="tool-btn button is-small"
          v-tooltip="{
            content: localization(
              'app-create-tasks-from-template',
              'Create tasks from template'
            ),
            placement: 'bottom-center',
          }"
        >
          <img
            v-if="active_button == 8"
            src="../../assets/icons/ticket-templates-selected.svg"
            alt
            srcset
          />
          <img
            v-else
            src="../../assets/icons/ticket-templates.svg"
            alt
            srcset
          />
        </a>
        <a
          v-if="$store.getters.forms"
          id="forms-bulk-create"
          @click="
            active_button = 9;
            post_bulk_create_event('forms-bulk-create');
          "
          class="tool-btn button is-small"
          v-tooltip="{
            content: localization(
              'app-create-forms-from-template',
              'Create forms from template'
            ),

            placement: 'bottom-center',
          }"
        >
          <img
            v-if="active_button == 9"
            src="../../assets/icons/form-templates-selected.svg"
            alt
            srcset
          />
          <img v-else src="../../assets/icons/form-templates.svg" alt srcset />
        </a>
        <span class="divider"></span>

        <a
          v-if="lang_data"
          id="tickets-bulk-actions"
          @click="active_button = 11"
          class="tool-btn button is-small"
          v-tooltip="{
            content: localization(
              'app-tasks-bulk-actions',
              'Tasks bulk actions'
            ),

            placement: 'bottom-center',
          }"
        >
          <img
            v-if="active_button == 11"
            src="../../assets/icons/bulk-icons/ticket-selected.svg"
            alt
            srcset
          />
          <img
            v-else
            src="../../assets/icons/bulk-icons/ticket.svg"
            alt
            srcset
          />
        </a>
        <a
          id="forms-bulk-actions"
          @click="active_button = 10"
          class="tool-btn button is-small"
          v-tooltip="{
            content: localization(
              'app-forms-bulk-actions',
              'Forms bulk actions'
            ),

            placement: 'bottom-center',
          }"
        >
          <img
            style="margin-top: 3px"
            v-if="active_button == 10"
            src="../../assets/icons/bulk-icons/form-selected.svg"
            alt
            srcset
          />
          <img v-else src="../../assets/icons/bulk-icons/form.svg" alt srcset />
        </a> -->
      </div>
    </div>
    <router-link
      v-tooltip="{
        content: localization('app-compare-map', 'Compare Map'),
        placement: 'top-center',
      }"
      style="border-radius: 8px; border: 0"
      :to="{ name: 'map-compare' }"
      tag="a"
      class="compare-icon has-text-white is-small"
    >
      <img src="@/assets/icons/compare.svg" />
      <!-- <span class="is-semibold-12-500-14">Compare Maps</span> -->
    </router-link>
    <sidebar :mapstyle="mapstyle" @sidebar="sidebar_active = $event"></sidebar>
    <p
      @click="toggle_mapstyle"
      class="map_style is-pointer"
      :style="{ left: sidebar_active ? '23rem' : '3.6rem' }"
      v-tooltip="{
        content:
          mapstyle == 'satellite'
            ? localization('app-street', 'Street')
            : localization('app-statellite', 'Satellite'),
      }"
    >
      <img v-if="mapstyle == 'street'" src="@/assets/satellite.jpg" />
      <img v-else src="@/assets/street.jpg" />
    </p>
    <right-sidebar></right-sidebar>
    <ExtraPropertiesFilter />
    <!-- <EbsCluster /> -->

    <!-- <div
      @click="toggle_marker()"
      class="map-marker is-pointer"
      style="
        margin-top: -2px;
        position: fixed;
        right: 10.6rem;
        top: 2.4rem;
        z-index: 38;
        width: 14px;
      "
    >
      <img
        v-if="map_marker_active"
        src="@/assets/icons/location-mark-selected.png"
        alt=""
      />
      <img v-else src="@/assets/icons/location-mark.png" alt="" />
    </div> -->
    <div
      v-tooltip="{
        content: localization('app-toggle-labels', 'Toggle labels'),
        placement: 'top-center',
      }"
      v-if="lang_data && $store.getters.show_feature_labels"
      @click="
        labels_active = !labels_active;
        toggle_labels();
      "
      class="map-marker is-pointer"
      style="
        margin-top: -2px;
        position: fixed;
        right: 6.7rem;
        top: 2.3rem;
        z-index: 38;
        width: 14px;
      "
    >
      <i class="fa fa-tag" :class="{ 'has-text-info': labels_active }"></i>
    </div>
    <div
      :class="{
        'bg-panel-show_feature_labels': $store.getters.show_feature_labels,
      }"
      class="bg-panel"
    ></div>

    <template>
      <a
        @click="TOGGLE_FLY_STATE(!fly_active)"
        class="fly_toggle"
        v-tooltip="{
          content: localization('app-toggle-fly', 'Toggle Fly'),
          placement: 'top-center',
        }"
      >
        <img v-if="fly_active" src="@/assets/icons/fly-active.svg" />
        <img v-else src="@/assets/icons/fly-inactive.svg" />
      </a>
    </template>
    <div id="map" @keydown="onkeydown($event)"></div>
  </div>
</template>
<script>
import { mapGetters, mapState, mapMutations } from "vuex";
import RightSidebar from "./components/right-sidebar/right-sidebar.component";
import ExtraPropertiesFilter from "./components/extra-properties-filter.component";
import EbsCluster from "./components/ebs-cluster.component";
import Sidebar from "@/components/sidebar/sidebar.component";
import FeatureTypeGroupService from "@/services/feature-type-group.service";
// mapbox
import APIService from "@/services/api.service";
const apiService = new APIService();

import axios from "axios";
import DrawRectangle from "mapbox-gl-draw-rectangle-mode";
// import MapboxDraw from "@mapbox/mapbox-gl-draw";
// mapbox

export default {
  components: {
    RightSidebar,
    Sidebar,
    ExtraPropertiesFilter,
    EbsCluster,
  },
  data() {
    return {
      toast: null,
      labels_active: false,
      map_marker_active: false,
      sidebar_active: true,
      active_button: -1,
      action_buttons: false,
      is_popup_active: false,
      popup_feature: null,
      featureTypeGroupService: new FeatureTypeGroupService(),
    };
  },
  async mounted() {
    this.$root.$on("create-project-ticket-completed", () => {
      this.active_button = -1;
      this.map_marker_active = false;
      if (this.map.getLayer("mapMarker"))
        this.map.setLayoutProperty("mapMarker", "visibility", "none");
    });

    await this.init_map();

    this.map.on("style.load", () => {
      this.INIT_FEATURE_COLORS();
    });
    this.map.on("load", () => {
      // if (localStorage.getItem("mapstyle") == "street") {
      //   this.map.setStyle("mapbox://styles/mapbox/streets-v11");
      // }
      this.INIT_DRAW(this.init_draw());
      this.map.addControl(new mapboxgl.NavigationControl(), "top-right");
      this.map.addControl(this.draw);
      this.featureTypeGroupService
        .getAll({
          query: `pk=true&${this.$store.state.route_name}=${this.$route.params.uid}`,
        })
        .then((res) => {
          this.SET_FEATURE_TYPE_GROUPS(res.data);
        });

      this.map.on("draw.modechange", (e) => {
        if (!this.active_project) {
          this.draw.changeMode("simple_select");
          this.$toast.open("Please Select Project Before Drawing anything.");
        }
        if (
          this.draw_mode &&
          this.draw_mode.startsWith("draw") &&
          e.mode == "simple_select" &&
          this.is_continuous_mode
        ) {
          this.draw.changeMode(this.draw_mode);
        } else {
          this.SET_DRAW_MODE(e.mode);
        }
      });
      this.map.on("draw.selectionchange", (e) => {
        this.SET_SELECTED_FEATURES(e.features);
        this.open_popup();
      });
      this.map.on("click", (e) => {
        // this.SET_SELECTED_FEATURES(e.features);
        this.open_popup();
        this.add_marker(e);
      });
      this.map.on("draw.update", (e) => {
        this.revert_non_editable_features();
      });
    });
  },
  watch: {
    map: function (val) {
      if (val) this.INIT_FEATURE_COLORS();
    },
    container: function (val) {
      if (val) this.INIT_FEATURE_COLORS();
    },
    feature_type_groups: function (val) {
      if (val) this.INIT_FEATURE_COLORS();
    },
    active_project: {
      handler(val) {
        if (
          this.active_project &&
          !this.active_projects[this.active_project.uid].project_details
        ) {
          apiService
            .get_project_details({
              group_id: this.active_project.group,
              id: this.active_project.uid,
            })
            .then((res) => {
              let project_details = res.data;
              if (_.isString(project_details.element)) {
                apiService
                  .get_element({ url: project_details.element })
                  .then((element) => {
                    project_details.element = element.data;
                    this.$store.commit("UPDATE_ACTIVE_PROJECTS", {
                      payload: {
                        ...this.active_projects[this.active_project.uid],
                        project_details,
                      },
                      layer: this.active_project,
                    });
                  });
              } else {
                this.$store.commit("UPDATE_ACTIVE_PROJECTS", {
                  payload: {
                    ...this.active_projects[this.active_project.uid],
                    project_details: res.data,
                  },
                  layer: this.active_project,
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      },
      immediate: true,
    },
    active_projects: {
      handler(val) {
        this.toggle_labels();
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState([
      "cluster_items_selected",
      "container",
      "feature_type_groups",
      "map",
      "active_project",
      "active_projects",
      "draw",
      "vectors",
      "features",
      "selected_features",
      "draw_mode",
      "is_continuous_mode",
      "fly_active",
    ]),
    shortcuts() {
      let arr = [];
      Object.values(this.vectors).forEach((v) => {
        arr[v.num_shortcut] = [v.class_id, v.class_name];
      });
      return arr;
    },
    mapstyle: {
      get() {
        return this.$store.state.mapstyle;
      },
      set(val) {
        this.$store.commit("SET_MAPSTYLE", val);
      },
    },
  },
  methods: {
    ...mapMutations([
      "UPDATE_FEATURE_COUNT",
      "INIT_MAP",
      "INIT_DRAW",
      "SET_DRAW_MODE",
      "INIT_FEATURE_COLORS",
      "SET_SELECTED_FEATURES",
      "SET_FEATURE_TYPE_GROUPS",
      "TOGGLE_CONTINUOUS_MODE",
      "TOGGLE_FLY_STATE",
    ]),
    toggle_labels() {
      if (this.labels_active && this.map && this.draw) {
        console.log("active_projects");
        let source = this.map.getSource("features_labels");
        if (source) {
          source.setData(this.draw.getAll());
        } else {
          this.map.addSource("features_labels", {
            type: "geojson",
            data: this.draw.getAll(),
          });
        }
        let layer = this.map.getLayer("features_labels");
        if (!layer) {
          this.map.addLayer({
            id: "features_labels",
            type: "symbol",
            source: "features_labels",
            paint: {
              "text-color": "yellow",
            },
            layout: {
              "text-field": ["get", "name"],
              "text-font": ["literal", ["Arial Unicode MS Regular"]],
              "text-size": 12,
            },
          });
        }
      } else if (this.map) {
        if (this.map.getLayer("features_labels"))
          this.map.removeLayer("features_labels");
        if (this.map.getSource("features_labels"))
          this.map.removeSource("features_labels");
      }
    },
    toggle_mapstyle() {
      if (this.mapstyle.includes("street")) {
        this.mapstyle = "satellite";
        this.map.setStyle("mapbox://styles/mapbox/satellite-v8");
      } else {
        this.map.setStyle("mapbox://styles/mapbox/streets-v11");
        this.mapstyle = "street";
        //   this.map.setLayoutProperty(
        //     "satellite",
        //     "visibility",
        //     "none"
        //   );
      }
    },
    open_popup() {
      this.active_button = -1;
      if (this.draw.getSelected().features.length > 0) {
        this.action_buttons = true;
      } else {
        this.action_buttons = false;
      }
    },
    async init_map() {

      if (process.env.VUE_APP_ENV === "nxt") {
          mapboxgl.accessToken = process.env.VUE_APP_MAPBOX_ACCESS_TOKEN;
          return;
        }

      let res, token;
      try {
        res = await axios.get(
          "https://sensehawk-config.s3.ap-south-1.amazonaws.com/mapbox-gl-token.json"
        );
        token = res.data.token;
      } catch (err) {
        token = null;
      }

      if (!token)
        mapboxgl.accessToken = process.env.VUE_APP_MAPBOX_ACCESS_TOKEN;
      else mapboxgl.accessToken = token;

      mapboxgl.setRTLTextPlugin(
        "https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js"
      );

      this.INIT_MAP(
        new mapboxgl.Map({
          container: "map",
          style:
            localStorage.getItem("mapstyle") == "street"
              ? "mapbox://styles/mapbox/streets-v11"
              : "mapbox://styles/mapbox/satellite-v8",
          center: [-122.0350127, 37.2805218],
          zoom: 0,
          maxZoom: 24,
          attributionControl: false,
        })
      );
    },
    init_draw() {
      const modes = MapboxDraw.modes;
      modes.draw_rectangle = DrawRectangle;
      return new MapboxDraw({
        keybindings: false,
        userProperties: true,
        displayControlsDefault: true,
        controls: {
          polygon: true,
          rectangle: true,
          trash: true,
        },
        modes: modes,
      });
    },
    revert_non_editable_features() {
      if (this.selected_features && this.selected_features.length) {
        if (this.selected_features.length === 1) {
          for (let feature of this.selected_features) {
            if (!feature.properties.editable) {
              this.draw.add(feature);
            }
          }
        } else if (this.selected_features.length > 1) {
          for (let feature of this.selected_features) {
            if (!this.edit_mode || !feature.properties.editable) {
              this.draw.add(feature);
            }
          }
        }
      }
    },
    changeClass(num) {
      if (this.shortcuts[num]) {
        for (let id of this.draw.getSelectedIds()) {
          this.draw.setFeatureProperty(id, "class_id", this.shortcuts[num][0]);
          this.draw.setFeatureProperty(id, "class_id", this.shortcuts[num][1]);
        }
      }
      this.$store.dispatch("update_vector_count");
      this.$store.dispatch(
        "set_selected_features",
        this.draw.getSelected().features
      );
    },
    onkeydown(e) {
      switch (e.key) {
        case "c": {
          this.TOGGLE_CONTINUOUS_MODE();
          this.draw.changeMode("simple_select");
          break;
        }
        case "r": {
          this.SET_DRAW_MODE("draw_rectangle");
          this.draw.changeMode("draw_rectangle");
          break;
        }
        case "p": {
          this.SET_DRAW_MODE("draw_polygon");
          this.draw.changeMode("draw_polygon");
          break;
        }
        case "m": {
          this.SET_DRAW_MODE("draw_point");
          this.draw.changeMode("draw_point");
          break;
        }
        case "l": {
          this.SET_DRAW_MODE("draw_line_string");
          this.draw.changeMode("draw_line_string");
          break;
        }
        case "Escape": {
          this.draw.changeMode("simple_select");
          break;
        }
        case "Delete" || "Backspace": {
          this.$emit("on_delete_feature");
          break;
        }
        case " ":
          this.duplicateFeatures();
          break;
        case "0":
        case "1":
        case "2":
        case "3":
        case "4":
        case "5":
        case "6":
        case "7":
        case "8":
        case "9":
          this.changeClass(e.key);
      }
    },
    duplicateFeatures() {
      let { features } = this.draw.getSelected();
      for (let feature of features) {
        delete feature["id"];
        delete feature.properties.editable;
        this.draw.add(feature);
      }
    },

    async add_marker_layer() {
      if (!this.map.hasImage("mapMarker")) {
        this.map.loadImage(
          "/img/icons/map-marker.png",
          async (error, image) => {
            if (error) {
              console.log("Imaage exists");
              //   throw error
            } else {
              this.map.addImage("mapMarker", image);
            }
          }
        );
      }
      if (!this.map.getSource("mapMarker")) {
        await this.map.addSource("mapMarker", {
          type: "geojson",
          data: { type: "FeatureCollection", features: [] },
        });
      }
      if (!this.map.getLayer("mapMarker")) {
        await this.map.addLayer({
          id: "mapMarker",
          type: "symbol",
          source: "mapMarker",
          layout: {
            "icon-image": "mapMarker",
            "icon-size": 1,
          },
        });
      }
    },
    toggle_marker() {
      this.map_marker_active = !this.map_marker_active;
      if (this.map_marker_active) {
        this.toast = this.$toast.open({
          duration: 1000000,
          message: this.localization(
            "app-tap-anywhere-on-the-map-to-add-a-task",
            "Tap anywhere on the map to add a ticket."
          ),
          position: "is-top",
        });
      } else {
        this.toast.close();
        this.map.setLayoutProperty("mapMarker", "visibility", "none");
        parent.postMessage(
          {
            name: "create-project-ticket",
            element: null,
          },
          "*"
        );
      }
    },
    add_marker(e) {
      this.add_marker_layer();
      if (this.map_marker_active && e) {
        if (this.toast) this.toast.close();
        setTimeout(() => {
          if (this.map.getLayer("mapMarker"))
            this.map.setLayoutProperty("mapMarker", "visibility", "visible");
          parent.postMessage(
            {
              open_on_create: true,
              name: "create-project-ticket",
              element: {
                ...this.active_projects[this.active_project.uid].project_details
                  .element,
                centroid: e.lngLat,
              },
            },
            "*"
          );
        }, 100);

        this.map.getSource("mapMarker").setData({
          type: "FeatureCollection",
          features: [
            {
              type: "Feature",
              geometry: {
                type: "Point",
                coordinates: Object.values(e.lngLat),
              },
            },
          ],
        });
      } else {
        this.toast = null;
        if (this.map.getLayer("mapMarker"))
          this.map.setLayoutProperty("mapMarker", "visibility", "none");
      }
    },
    post_bulk_create_event(event_name) {
      let selected = this.draw.getSelected();
      if (selected.features.length) {
        parent.postMessage(
          {
            name: event_name,
            features: selected.features,
            assetUid:
              this.container.properties && this.container.properties.asset,
          },
          "*"
        );
      }
    },
  },
};
</script>
<style lang="scss">
#map {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: 100vh;
}

.mapboxgl-ctrl-top-right {
  bottom: 1rem;
  // @media (min-width: 768px) and (max-width: 1024px) {
  // right: 6rem;
  // }
}
.mapboxgl-ctrl-top-right .mapboxgl-ctrl {
  margin: 22px 15px 0 0;
}

.compare-icon {
  position: absolute;
  z-index: 100;
  bottom: 3.5rem;
  right: 1rem;
}

.feature-action-buttons {
  height: 0;
  top: 20px;
  position: absolute;
  z-index: 40;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 0 auto;
  text-align: center;

  div {
    display: flex;
    align-items: center;
    height: 50px;
    background-color: #fff;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.3);
    border-radius: 0 0 4px 4px;
    padding-right: 15px;
    padding-left: 15px;
  }

  .button {
    height: 36px;
    width: 36px;
    margin-right: 4px;
    margin-left: 4px;
    border-radius: 0px;
    color: #1f376c;
    border: 0;

    img {
      height: 18px !important;
      width: 18px !important;
    }

    &:hover {
      border-radius: 50%;
      background-color: #f2f2f2;
    }
  }

  &-active.button {
    height: 36px;
    width: 36px;
    color: #ffffff;
    border-radius: 50%;
    background: #5c7ef7;

    &:hover {
      border-radius: 50%;
      background-color: #5c7ef7;
    }
  }
}
.is-disabled {
  pointer-events: none;
  opacity: 0.4;
  cursor: default !important;
}
.fly_toggle {
  position: fixed;
  top: 2.2rem;
  right: 4.4rem;
  z-index: 30 !important;
  transform: rotate(-90deg);
}
.map_style {
  position: fixed;
  bottom: 1rem;
  // left: 23rem;
  height: 3.5rem;
  border: 2px solid white;
  border-radius: 6px;
  img {
    border-radius: 6px;
  }
  z-index: 30 !important;
}
.bg-panel {
  position: fixed;
  top: 1.8rem;
  right: 3.75rem;
  width: 8.8rem;
  height: 2.15rem;
  background-color: white;
  border-radius: 0.2rem;
  z-index: 30;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.3);
  &-show_feature_labels {
    width: 6.8rem;
  }
}
.divider {
  width: 0;
  height: 20px;
  margin: 2px 0 2px;
  opacity: 0.1;
  border: solid 1px #171e48;
}
</style>
